import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drop-block pointer" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "drop-img" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drop-file", {error: $props.error}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" <Loader v-if=\"loading\">\n        Uploading a document...\n      </Loader> "),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Icon, {
          class: "upload-icon",
          stroke: "var(--gray-700)",
          icon: "upload-02",
          width: "2rem",
          height: "2rem"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "click-to" }, " Drop to upload ", -1 /* HOISTED */)),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
        _createTextVNode(" " + _toDisplayString($options.exts_text), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Icon, {
          icon: "custom/file-drop",
          alt: "drop"
        })
      ])
    ])
  ], 2 /* CLASS */))
}